import Successful from '@/api/successful.js'

let cachedCategories = null
let fetchPromise = null

export function getSuccessfulCategories () {
  if (cachedCategories) {
    return Promise.resolve(cachedCategories)
  }
  if (fetchPromise) {
    return fetchPromise
  }
  fetchPromise = new Promise(async (resolve, reject) => {
    try {
      const params = { page: null, pageSize: null, startStatus: 1 }
      const response = await Successful.getTypeList(params)
      const { code, data, msg } = response
      if (code === 200) {
        cachedCategories = data.filter(item => item.startStatus === 1)
        resolve(cachedCategories)
      } else {
        reject(new Error(msg || `获取成功案例分类失败 (code: ${code})`))
      }
    } catch (error) {
      console.error('[getSuccessfulCategories] 请求异常:', error)
      reject(error)
    } finally {
      fetchPromise = null
    }
  })
  return fetchPromise
}



// WEBPACK FOOTER //
// ./src/utils/successfulCategoryStore.js